import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CommunityService } from '../../../services/community.service';
import { AuthService } from '../../../app/guards/service/auth.service';

@Component({
  selector: 'app-community-detail',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './community-detail.component.html',
  styleUrls: ['./community-detail.component.css'],
})
export class CommunityDetailComponent implements OnInit {
  community: any = null;
  error = '';
  totalUsers = 0;
  spaceID = 0;

  constructor(
    private route: ActivatedRoute,
    private communityService: CommunityService,
    private router: Router,
    private auth: AuthService
  ) {}

  ngOnInit(): void {
    const slug = (this.route.snapshot.paramMap.get('slug') || '').trim();
    if (!slug) return;

    // PUBLIC call only
    this.communityService.getCommunityBySlug(slug).subscribe({
      next: (res: any) => {
        this.community = res?.data || null;
        this.totalUsers = Number(res?.total_users ?? 0);

        const communityId = Number(this.community?.id ?? 0);
        this.spaceID = Number(this.community?.Spaces?.id ?? 0);
        if (!communityId) {
          this.error = 'Community not found.';
          return;
        }

     
        sessionStorage.setItem('pendingSlug', slug);
        sessionStorage.setItem('pendingCommunityId', String(communityId));
        if (this.spaceID) sessionStorage.setItem('pendingSpaceID', String(this.spaceID));

        localStorage.setItem('slug', slug);
        localStorage.setItem('communityId', String(communityId));

       
      },
      error: () => (this.error = 'Community not found or error occurred.'),
    });
  }

onJoinCommunity(): void {
  const communityId = Number(this.community?.id ?? 0);
  const slug =
    String(this.route.snapshot.paramMap.get('slug') || '').trim() ||
    String(this.community?.community_url ?? '').trim();
  const spaceID = Number(this.spaceID || this.community?.Spaces?.id || 0);

  if (!slug || !communityId) return;


  sessionStorage.setItem('pendingSlug', slug);
  sessionStorage.setItem('pendingCommunityId', String(communityId));
  if (spaceID) sessionStorage.setItem('pendingSpaceID', String(spaceID));
  localStorage.setItem('slug', slug);
  localStorage.setItem('communityId', String(communityId));

  if (this.auth.isLoggedIn()) {
    if (this.auth.hasMembership(spaceID)) {
    
      this.router.navigate(['/', slug, communityId, 'home'], { replaceUrl: true });
      return;
    }
  
    this.auth.handleLogout(); 
    return;
  }

  this.router.navigate(['/', slug, communityId, 'login'], { replaceUrl: true });
}


}
